import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
  nanoid,
} from '@reduxjs/toolkit'
import { IToasterMessage } from 'shared/models/Toaster'

// @ts-expect-error - TODO: fix this ts error
export const toasterMessages = createEntityAdapter<IToasterMessage>({
  selectId: (message) => message.id || nanoid(),
})

const toasterSlice = createSlice({
  name: 'toaster',
  initialState: toasterMessages.getInitialState(),
  reducers: {
    removeToasterMessage: toasterMessages.removeOne,
  },
  extraReducers: (builder) => {
    builder.addCase(addToasterMessage.fulfilled, (state, action) => {
      toasterMessages.addOne(state, action.payload)
    })
  },
})

const addToasterMessage = createAsyncThunk<IToasterMessage, IToasterMessage>(
  'toaster/addToasterMessage',
  async (arg, api) => {
    const id = nanoid()

    setTimeout(() => {
      api.dispatch(toasterSlice.actions.removeToasterMessage(id))
    }, arg.duration || 5000)

    return { ...arg, id: arg.id || id }
  }
)

export const { reducer, actions } = toasterSlice
export { addToasterMessage }
